<template>
    <div v-if="Object.keys(ticketData).length > 0" class="riepilogo-dati-utente-ticket">
        <div class="title">{{ intl[$store.state.lang]["title"]}}</div>
        <div class="lista-dati">
            <div v-for="(infoType, index) in infoTypes"  :key="index" class="text-start">
                <div class="dato-utente" v-if="Object.keys(ticketData).indexOf(infoType) !== -1 && ticketData[infoType]">
                    <div class="tipo-dato">{{intl[$store.state.lang][infoType]}}</div>
                    <span class="badge rounded-pill bg-secondary">
                        <div :title="ticketData[infoType]" class="valore-dato">{{dataParser(ticketData[infoType],infoType)}}</div>
                    </span>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import {apiUrls} from "../../api/apiUrls"
import {formatDate} from '../../api/apiUtils'
export default {
    name: "riepilogoDatiUtenteTicket",
    mounted() {},
    props: {
        
        ticketId: {
            type: Number,
            default: null,
            required: true
        },
        
        setPaginaLoaderCallback: {
            type: Function,
            default: (value) => {console.log("TICKET LOADER: ",value)},
      },
      onGetDataCallback: {
            type: Function,
            default: (response) => {console.log("DATA CALLBACK: ",response)},
        }
        
    },
    created() {
      this.getTicketDetail()
    },
    

    data: function () {
        return {
            intl: intl,
            riepilogoDatiUtenteTicketLoader : false,
            ticketData: {},
            infoTypes: [],
            ticketArea: null
        };
    },
    methods: {
        dataParser(data,infoType) {
          
            if(infoType === "birthday"){
                let d = new Date(data)
                return formatDate(d,true)
                
            }else{
                return data
            }
        },
        getInfoTypes(area){
            switch(area){
                case "6":
                    this.infoTypes = ["name","surname","email","codfisc","piva","mobile","ragione_sociale","importo_richiesto","importo_ricevuta","IBAN","intestatario","BIC_SWIFT","data_bonifico","data_pagamento"]
                    break
                default:
                    this.infoTypes = ["name","surname","email","telefon_mobile","contact_times"]
                    break
            }
        },

        getTicketDetail() {
            if(this.ticketId){
                this.riepilogoDatiUtenteTicketLoader = true;
                axios.get(apiUrls["ticket_detail"] + this.ticketId)
                    .then((response) => {
                        if(response && response.data){
                            this.ticketData = response.data
                            this.ticketArea = this.ticketData['area']
                            this.getInfoTypes(this.ticketData['area'])
                            //ad hoc per wiper assistenza
                            if(this.ticketData['telefon'] && this.ticketData['mobile']){
                                this.ticketData['telefon_mobile'] = this.ticketData['telefon'] + ' / ' + this.ticketData['mobile']
                            }else if(this.ticketData['telefon']){ 
                                this.ticketData['telefon_mobile'] = this.ticketData['telefon']
                            }else if(this.ticketData['mobile']){
                                this.ticketData['telefon_mobile'] = this.ticketData['mobile']
                            }
                            
                            
                        }
                        this.onGetDataCallback(response)
                        this.riepilogoDatiUtenteTicketLoader = false
                    })
                    .catch((error) => {
                        this.onGetDataCallback(null)
                        this.riepilogoDatiUtenteTicketLoader = false
                    }); 
            }
        }
    },
    watch: {
        riepilogoDomandeRisposteLoader : {
                handler : function(newValue, oldValue) {
                    if(oldValue !== newValue){
                        this.setPaginaLoaderCallback({riepilogoDatiUtenteTicket: newValue})
                    }                
                },
                immediate: true, 
        },
        
    },
    computed: {
        
    },
};
</script>
